module.exports = __webpack_public_path__ + "img/Malaysia-2-hover.8dc5fcdc.jpg";